export default __webpack_public_path__ + "static/media/right-arrow.bff628d0.svg";